import { useBreakpointValue } from "@chakra-ui/react";

type CarouselSettingsProps = {
  dots: boolean;
  autoplay: boolean;
  slidesToShow?: number;
};

export const useCustomerCarousel = ({
  dots,
  autoplay,
  slidesToShow,
}: CarouselSettingsProps) => {
  const defaultSlidesToShow = useBreakpointValue({
    base: 1,
    sm: 3,
    md: 4,
    lg: 8,
  });
  const settings = {
    arrows: false,
    autoplay: autoplay,
    autoplaySpeed: 2000,
    dots: dots,
    centerMode: false,
    infinite: true,
    pauseOnHover: true,
    slidesToScroll: 1,
    slidesToShow: slidesToShow ?? defaultSlidesToShow,
    swipeToSlide: true,
  };

  return {
    settings,
  };
};
